import React from "react";
import { connect } from "react-redux";
import { analyticsFEA } from "src/AnalyticsFEA";
import Description from "src/components/Accessories/Elements/Description";
import Image from "src/components/Accessories/Elements/Image";
import DocumentLink from "src/components/Accessories/Elements/DocumentLink";
import Price from "src/components/Accessories/Elements/Price";
import SelectionButton from "src/components/Accessories/Elements/SelectionButton";
import Title from "src/components/Accessories/Elements/Title";
import { ApplicationStore } from "src/store";
import { deleteAccessoryRequest, postAccessoryRequest } from "src/store/actions/accessories";
import {
    getAccessoryDescription,
    getAccessoryDocumentTitle,
    getAccessoryDocumentUrl,
    getAccessoryExcerpt,
    getAccessoryImage,
    getAccessoryPaymentDisplayText,
    getAccessoryPaymentFrequencyDisplayKey,
    getAccessoryPriceAltText,
    getAccessoryPriceDisplayText,
    getAccessoryTitle,
} from "src/store/selectors/accessories";

interface Props {
    vin: string;
    accessoryId: number;
    onAccessoriesChange(): void;
}

const DealCard = ({
    uuid,
    vin,
    accessoryId,
    imageUrl,
    title,
    description,
    documentTitle,
    documentUrl,
    excerpt,
    price,
    priceAltText,
    payment,
    frequencyKey,
    isSelected,
    isUpdating,
    onAccessoriesChange,
    postAccessory,
    deleteAccessory,
}: Props & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
    const handleAdd = () => {
        onAccessoriesChange();
        postAccessory(uuid, vin, accessoryId);
        analyticsFEA.engine.addUpgrade(accessoryId);
    };

    const handleRemove = () => {
        deleteAccessory(uuid, vin, accessoryId);
    };

    return (
        <div className={`accessories_deal_card`}>
            <div className={`accessories_deal_card_left`}>
                <Image imageUrl={imageUrl} isSelected={isSelected} />
            </div>
            <div className={`accessories_deal_card_right`}>
                <div>
                    <Title title={title} />
                    <Price price={price} priceAltText={priceAltText} payment={payment} frequencyKey={frequencyKey} />
                    <Description description={description} excerpt={excerpt} />
                    <DocumentLink documentTitle={documentTitle} documentUrl={documentUrl} />
                </div>
                <SelectionButton
                    isSelected={isSelected}
                    isUpdating={isUpdating}
                    handleAdd={handleAdd}
                    handleRemove={handleRemove}
                />
            </div>
        </div>
    );
};

const mapStateToProps = (state: ApplicationStore, { vin, accessoryId }: Props) => ({
    uuid: state.deal.uuid!,
    imageUrl: getAccessoryImage(state, vin, accessoryId),
    title: getAccessoryTitle(state, vin, accessoryId),
    description: getAccessoryDescription(state, vin, accessoryId),
    documentTitle: getAccessoryDocumentTitle(state, vin, accessoryId),
    documentUrl: getAccessoryDocumentUrl(state, vin, accessoryId),
    excerpt: getAccessoryExcerpt(state, vin, accessoryId),
    price: getAccessoryPriceDisplayText(state, vin, accessoryId),
    priceAltText: getAccessoryPriceAltText(state, vin, accessoryId),
    payment: getAccessoryPaymentDisplayText(state, vin, accessoryId),
    frequencyKey: getAccessoryPaymentFrequencyDisplayKey(state, vin),
    isSelected: !!state.accessories?.[vin]?.selected?.includes(accessoryId),
    isUpdating: !!state.accessories?.[vin]?.updating?.includes(accessoryId),
});

const mapDispatchToProps = {
    postAccessory: postAccessoryRequest,
    deleteAccessory: deleteAccessoryRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(DealCard);
